/**
 * Lista de valores comparados entre si con una barra proporcional al mayor.
 *
 * Un numero suelto no dice si es mucho o poco al lado de los demas: 59
 * contactos por ficha se lee distinto junto a una barra larga que junto a un
 * "3" de checkout con el mismo tamano de letra. Reutiliza `.barra-prog`, que
 * ya estaba en `administracion.css` sin ningun componente que la usara.
 */
import { numero } from '../../utilidades/formato';

export interface ItemBarra {
  etiqueta: string;
  valor: number;
}

export interface ListaBarrasProps {
  items: ItemBarra[];
}

export function ListaBarras({ items }: ListaBarrasProps) {
  const maximo = Math.max(...items.map((item) => item.valor), 1);

  return (
    <ul className="lista-barras">
      {items.map((item) => (
        <li key={item.etiqueta}>
          <div className="lista-barras-cab">
            <span>{item.etiqueta}</span>
            <span className="num">{numero(item.valor)}</span>
          </div>
          <div className="barra-prog">
            <i style={{ width: `${Math.round((item.valor / maximo) * 100)}%` }} />
          </div>
        </li>
      ))}
    </ul>
  );
}
